<script setup lang="ts">
  import { toRefs } from 'vue';
  import { BaseDropdown } from '@/shared/ui/base-dropdown';
  import { usePortalDialog } from '../../model/composables/use-portal-dialog';
  import type { PortalView } from 'dfx/edge/edge.did';
  import { usePortalUserStatus } from '../../model/composables/use-portal-user-status';

  const props = defineProps<{
    portalView: PortalView;
  }>();

  defineEmits<{
    (e: 'share'): void;
  }>();

  const { portalView } = toRefs(props);
  const { isPortalFavorited, toggleFavorite, isPortalJoined } =
    usePortalUserStatus();
  const { openLeaveDialog } = usePortalDialog();
</script>
<template>
  <base-dropdown
    :distance="5"
    placement="bottom-end"
    append-to-body
    custom-content-classes="bg-gray-900 border border-gray-785 border-opacity-50 transition-all duration-300 ease-in-out drop-shadow-heavy py-2 min-w-52"
  >
    <template #button="{ toggle }">
      <base-button variant="glass" size="x-small" @click="toggle">
        <base-icon name="vertical-dots" size="size-5" />
      </base-button>
    </template>
    <template #content="{ hide }">
      <base-button
        variant="custom"
        size="small"
        custom-classes="flex gap-2 w-full px-4 py-3 text-left text-white hover:bg-gray-800 capitalize"
        @click="hide(), $emit('share')"
      >
        <base-icon name="outlined-share" size="size-5" />
        <span>{{ $t('sharePortal') }}</span>
      </base-button>
      <base-button
        v-if="isPortalJoined(portalView) && !isPortalFavorited(portalView)"
        variant="custom"
        size="small"
        custom-classes="flex gap-2 w-full px-4 py-3 text-left text-white hover:bg-gray-800 capitalize"
        @click="hide(), toggleFavorite(portalView)"
      >
        <base-icon name="outline-star" size="size-5" />
        <span>{{ $t('favoritePortals.addToFavorites') }}</span>
      </base-button>

      <div
        v-if="isPortalJoined(portalView)"
        class="border-t border-white border-opacity-12 mx-5 my-2"
      />
      <base-button
        v-if="isPortalJoined(portalView)"
        variant="custom"
        size="small"
        custom-classes="flex gap-2 w-full px-4 pt-3 pb-5 text-left text-red-400 hover:bg-gray-800 capitalize"
        @click="hide(), openLeaveDialog()"
      >
        {{ $t('leavePortal') }}
      </base-button>
    </template>
  </base-dropdown>
</template>
